import { INoRowsOverlayAngularComp } from '@ag-grid-community/angular';
import { INoRowsOverlayParams } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { VendorWorkflowDirective } from '@features/feature-workflow/directives/vendor-workflow.directive';

import { ButtonComponent } from '@shared/components/button/button.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

export type VendorGridOverlayNoRowCellParams = INoRowsOverlayParams & {
  onAddMultipleVendorsFN: (() => void) | undefined;
  onNewVendorFN: (() => void) | undefined;
};

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [
    {
      directive: VendorWorkflowDirective,
    },
  ],
  imports: [TooltipDirective, ButtonComponent],
  selector: 'aux-vendor-grid-overlay-no-row-cell',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  templateUrl: './vendor-grid-overlay-no-row-cell.component.html',
})
export class VendorGridOverlayNoRowCellComponent implements INoRowsOverlayAngularComp {
  ctx = inject(VendorWorkflowDirective);

  public params!: VendorGridOverlayNoRowCellParams;

  agInit(params: VendorGridOverlayNoRowCellParams): void {
    this.params = params;
  }

  onAddMultipleVendors(params: VendorGridOverlayNoRowCellParams) {
    if (params.onAddMultipleVendorsFN) {
      params.onAddMultipleVendorsFN();
    }
  }

  onNewVendor(params: VendorGridOverlayNoRowCellParams) {
    if (params.onNewVendorFN) {
      params.onNewVendorFN();
    }
  }

  refresh(): boolean {
    return false;
  }
}
